import React from 'react'

export default function PowerpointToPdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <g clip-path="url(#a)">
          <g mask="url(#b)">
            <path
              fill="currentColor"
              d="m25.91 5.89-.3-.3L21.02 1l-.2-.2c-.5-.5-1.2-.8-1.9-.8H3.05C1.55 0 .25 1.3.25 2.8v26.85c0 1.6 1.3 2.8 2.8 2.8h13.18c-.2-.3-.3-.7-.4-1H3.25c-1.1 0-2-.9-2-2V2.9c0-1 .8-1.8 1.8-1.8h15.97c.3 0 .7.1.9.4l.5.5 4.19 4.19.7.7c.2.2.3.4.3.7v12.28c.3 0 .6.1.9.1V7.49c0-.6-.2-1.2-.6-1.6Z"
            />
            <path
              fill="currentColor"
              fill-opacity=".1"
              d="M26.57 7.81v12.11c-.61-.1-1.21-.2-1.82-.2-4.85-.3-8.99 3.33-9.4 8.07v1.01c0 1.11.2 2.32.71 3.33H2.52c-1.11 0-2.02-.91-2.02-2.02V2.26C.5 1.15 1.41.24 2.52.24H19.5c.51 0 1.01.2 1.41.61l5.05 5.25c.4.4.61 1.11.61 1.72v-.01Z"
              opacity=".1"
            />
            <path
              fill="currentColor"
              d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9c-4.1 0-7.5 3.3-7.5 7.5s3.3 7.5 7.5 7.5 7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
            />
            <path
              fill="currentColor"
              fill-opacity=".1"
              d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm-2.035-12.289H6.58c-.322 0-.564-.209-.564-.487v-4.736c0-.279.242-.488.564-.488h15.926c.322 0 .564.209.564.488v4.7c0 .28-.282.523-.605.523Z"
            />
            <path
              fill="currentColor"
              fill-opacity=".1"
              d="M6.58 17.711c-.322 0-.564-.209-.564-.487L6 13.324H4.564c-.322 0-.564.209-.564.487v4.701c0 .28.242.488.564.488H20.45c.323 0 .605-.209.605-.488v-.8L6.58 17.711Z"
            />
            <path
              fill="currentColor"
              d="M22.82 12.487c0-.108-.095-.238-.314-.238H6.58c-.22 0-.314.13-.314.238v4.737c0 .106.094.237.314.237l15.885-.001c.22 0 .355-.164.355-.271v-4.702ZM4.25 18.512c0 .108.095.238.314.238H20.45c.245 0 .355-.15.355-.238v-.551H6.58c-.424 0-.814-.287-.814-.736l-.015-3.65H4.564c-.219 0-.314.129-.314.236v4.7Zm19.07-1.323c0 .45-.43.77-.855.77h-1.16v.553c0 .47-.453.738-.855.738H4.564c-.424 0-.814-.287-.814-.738V13.81c0-.448.39-.736.814-.736h1.202v-.587c0-.45.39-.738.814-.738h15.926c.425 0 .814.288.814.738v4.702Z"
            />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M7.125 4.833a1.266 1.266 0 0 0-.59-.122h-.83v1.94h.835c.237 0 .432-.04.585-.122a.811.811 0 0 0 .347-.343c.078-.148.116-.318.116-.51a1.05 1.05 0 0 0-.116-.505.778.778 0 0 0-.347-.338Z"
              clip-rule="evenodd"
            />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M9.62 2.875c.398 0 .736.338.736.735v6.01a.748.748 0 0 1-.736.736H3.61a.747.747 0 0 1-.735-.736V3.61c0-.397.338-.735.736-.735h6.01-.001ZM4.475 9.523V3.705h2.296c.44 0 .816.085 1.127.253.31.167.548.399.71.696.165.296.248.637.248 1.023 0 .386-.084.727-.25 1.022-.168.297-.42.537-.725.69-.314.165-.695.248-1.141.248H5.705v1.886h-1.23Z"
              clip-rule="evenodd"
            />
          </g>
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h32v36H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
